import { observer } from 'mobx-react'
import React, { useState, useEffect } from 'react'
import PopupStore, { POPUPS_IDS } from '../../../stores/PopupStore'

import './Badge.css'

const Badge = ({data}) => {

  let cl = "Badge"
  cl += data.wasActive ? " active" : " inactive"
  return (
    <div className={cl} onClick={() => PopupStore.open(POPUPS_IDS.ADVISOR, data.description)}>
      <div className="badge-image" style={{ backgroundImage: `url(./images/badges/${data.id}.png)` }} />

      <div className="badge-title" style={{top: data.title_yoffset + "%"}}>
        <div className="badge-title1" style={{color: data.title_color}} >{data.title1}</div>
        <div className="badge-title2" style={{color: data.title_color}} >{data.title2}</div>
      </div>

      <div
      className="badge-subtitle"
      style={{color: data.subtitle_color, top: data.subtitle_yoffset + "%"}}
      dangerouslySetInnerHTML={{__html: data.subtitle}} />

      {data.notif && <div className="notif">!</div>}
    </div>
  )
}

export default observer(Badge)
